import React, { useEffect, useState } from "react";
import { Box, Stack } from "@mui/material";
import Paper from "@mui/material/Paper";
import _ from "lodash";
import { context_styles, list_styles } from "../../context_builder_dark_styles";
import "../../context_dark.css";
import axios from "axios";
import { LinearProgressDark } from "../../context_components/styled_linear_progress";
import { StyledAutocompleteDark } from "../../context_components/styled_autocomplete";
import TextField from "@mui/material/TextField";
import { makeStyles } from "@mui/styles";
import { Tag } from "antd";
import { useSpring, animated } from "@react-spring/web";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePickerWhite } from "../../../ImageViewer/ImageViewerLikeContext/DatePickerWhite";
import {
  setSnackbarMessage,
  setSnackbarMessageSeverity,
  setSnackbarOpen,
} from "../../../store/comprehensiveImageViewer/feedbackSlice";
import {
  defaultTabActions,
  contextBuilderActions,
  sosAndSodActions,
  imageAnalysisActions,
  analysisActions,
  projectInfoActions,
  feedbackActions,
} from "../../../store/store";
import { Collapse } from "@mui/material";
import { Projects } from "../../context_components/projects";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { BootstrapTooltip } from "../../context_builder_dark_styles";
import { sosSodSlice } from "../../../store/context/sosSodSlice";
// import { setAuditResultData } from "../../../store/context/sosSodSlice";

const useAutoCompleteStyles = makeStyles({
  option: {
    fontSize: "0.875rem",
  },
});

export default function DefaultSearchMode(props) {
  const autocomplete_classes = useAutoCompleteStyles();
  const { projectInfo, projects } = useSelector(
    (state) => state.projectInfoStore
  );
  const searchEntity = useSelector(
    (state) => state.defaultTabStore.search_input
  );
  const load = useSelector((state) => state.contextBuilderStore.load);
  const { loading } = useSelector((state) => state.feedbackStore);
  const { color, col_100 } = useSelector((state) => state.themeStore);
  const baseProject = projectInfo[2];
  const [date, setDate] = useState(null);
  const [enterDate, setEnterDate] = useState(null);

  const config = projects.filter(
    (r) => r.country === projectInfo[0] && r.env === projectInfo[1]
  )[0];

  const {
    currentSearchMode,
    searchModes,
    storeData,
    sessionAuditList,
    userList,
    storeList,
    audits,
    selectedAudit,
    selectedOption,
    selectedType,
    rawData,
  } = useSelector((state) => state.defaultTabStore);
  const { analysisOptions } = useSelector((state) => state.analysisStore);
  const annotation = analysisOptions.annotation.selected;

  const dispatch = useDispatch();

  const [springs, api] = useSpring(() => ({
    from: {
      y: 0,
    },
    config: {
      mass: 7,
    },
  }));

  useEffect(() => {
    api.start({
      from: {
        opacity: 0,
        y: -15 + "%",
      },
      to: {
        opacity: 1,
        y: 0 + "%",
      },
    });
  }, []);

  const make_list = (type, data) => {
    if (type === "store") {
      let list = [];
      const store_details = Object.values(data)[0];
      const session_audit_idx = store_details[0].indexOf("session_audit");
      const store_idx = store_details[0].indexOf("address");
      const userIdx = store_details[0].indexOf("email_id");
      const session_audits = store_details
        .slice(1, store_details.length)
        .map((row) => row[session_audit_idx]);
      const users = store_details
        .slice(1, store_details.length)
        .map((row) => row[userIdx]);
      const stores = store_details
        .slice(1, store_details.length)
        .map((row) => row[store_idx]);
      dispatch(
        defaultTabActions.setSessionAuditList([...new Set(session_audits)])
      );
      dispatch(defaultTabActions.setUserList([...new Set(users)]));
      dispatch(defaultTabActions.setStoreList([...new Set(stores)]));
      return list;
    }
  };

  const isValidDate = (dateStr) => {
    const date = new Date(dateStr);
    const isInvalid = isNaN(date.getTime());

    return !isInvalid && date.toISOString().split("T")[0] === dateStr;
  };

  // const handleKeyDown = (e) => {
  //   switch (e.keyCode || e.which) {
  //     case 13:
  //       e.preventDefault();

  //       if (!isValidDate(searchEntity)) {
  //         dispatch(feedbackActions.setSnackbarOpen(true));
  //         dispatch(feedbackActions.setSnackbarMessage("Enter a valid date!"));
  //         dispatch(feedbackActions.setSnackbarMessageSeverity("error"));
  //         return;
  //       }

  //       // clearing filter options
  //       let refresh_selected_option = { ...selectedOption };
  //       Object.keys(refresh_selected_option).map((option) => {
  //         refresh_selected_option[option] = "";
  //       });
  //       dispatch(defaultTabActions.setSelectedOption(refresh_selected_option));
  //       dispatch(defaultTabActions.setStoreData([]));
  //       dispatch(defaultTabActions.setAuditList([]));
  //       dispatch(defaultTabActions.setSessionAuditList([]));
  //       dispatch(defaultTabActions.setUserList([]));
  //       dispatch(defaultTabActions.setStoreList([]));

  //       const params = {
  //         start_date: searchEntity,
  //         end_date: searchEntity,
  //         config: config.tag,
  //       };

  //       dispatch(feedbackActions.setLoading(true));
  //       axios
  //         .post("/get_context/get_store_context", params)
  //         .then((response) => {
  //           if (Object.values(response.data)[0].length > 0) {
  //             let data = response.data;
  //             if (annotation) {
  //               // filtering data if annotation filter is on
  //               let key = Object.keys(data)[0];
  //               let aoa = Object.values(data)[0];
  //               const cols = aoa[0];
  //               const annotationStatusIdx = aoa[0].indexOf("annotationStatus");
  //               data = {
  //                 [key]: [
  //                   cols,
  //                   ...aoa.filter(
  //                     (r) => r[annotationStatusIdx] === "annotated"
  //                   ),
  //                 ],
  //               };
  //             }

  //             dispatch(defaultTabActions.setRawData(response.data));
  //             dispatch(defaultTabActions.setStoreData(Object.values(data)[0]));
  //             make_list("store", data);
  //             dispatch(feedbackActions.setLoading(false));
  //           } else {
  //             dispatch(feedbackActions.setSnackbarOpen(true));
  //             dispatch(feedbackActions.setSnackbarMessage("Data unavailable!"));
  //             dispatch(feedbackActions.setSnackbarMessageSeverity("warning"));
  //             dispatch(feedbackActions.setLoading(false));
  //           }
  //         })
  //         .catch((error) => {
  //           console.log(error);
  //         });
  //       break;
  //   }
  // };

  // const handleTextChange = (e) => {
  //   dispatch(defaultTabActions.handleInput(e.target.value));
  // };

  const handleTextChange = async (newDate) => {
    const formattedDate = moment(newDate).format("YYYY-MM-DD");

    const isValidDate = (formattedDate) => {
      const dateCheck = new Date(formattedDate);
      const isInvalid = isNaN(dateCheck.getTime());
      return (
        !isInvalid && dateCheck.toISOString().split("T")[0] === formattedDate
      );
    };

    if (isValidDate) {
      dispatch(defaultTabActions.handleInput(formattedDate));
      setDate(formattedDate);
      setEnterDate(formattedDate);
    } else {
      dispatch(setSnackbarOpen(true));
      dispatch(setSnackbarMessage("Enter a valid date!"));
      dispatch(setSnackbarMessageSeverity("error"));
      return;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (enterDate && enterDate !== "Invalid date") {
        let refresh_selected_option = { ...selectedOption };
        Object.keys(refresh_selected_option).map((option) => {
          refresh_selected_option[option] = "";
        });
        dispatch(defaultTabActions.setSelectedOption(refresh_selected_option));
        dispatch(defaultTabActions.setStoreData([]));
        dispatch(defaultTabActions.setAuditList([]));
        dispatch(defaultTabActions.setSessionAuditList([]));
        dispatch(defaultTabActions.setUserList([]));
        dispatch(defaultTabActions.setStoreList([]));

        const params = {
          start_date: searchEntity,
          end_date: searchEntity,
          config: config.tag,
        };

        dispatch(feedbackActions.setLoading(true));
        axios
          .post("/get_context/get_store_context", params)
          .then((response) => {
            if (Object.values(response.data)[0].length > 0) {
              let data = response.data;
              if (annotation) {
                // filtering data if annotation filter is on
                let key = Object.keys(data)[0];
                let aoa = Object.values(data)[0];
                const cols = aoa[0];
                const annotationStatusIdx = aoa[0].indexOf("annotationStatus");
                data = {
                  [key]: [
                    cols,
                    ...aoa.filter(
                      (r) => r[annotationStatusIdx] === "annotated"
                    ),
                  ],
                };
              }

              dispatch(defaultTabActions.setRawData(response.data));
              dispatch(defaultTabActions.setStoreData(Object.values(data)[0]));
              make_list("store", data);
              dispatch(feedbackActions.setLoading(false));
            } else {
              dispatch(feedbackActions.setSnackbarOpen(true));
              dispatch(feedbackActions.setSnackbarMessage("Data unavailable!"));
              dispatch(feedbackActions.setSnackbarMessageSeverity("warning"));
              dispatch(feedbackActions.setLoading(false));
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    };

    fetchData();
  }, [enterDate]);

  // useEffect(() => {
  //   if (searchEntity) {
  //     setDate(searchEntity);
  //     setEnterDate(searchEntity);
  //   }
  // }, [searchEntity]);

  const handlePageChange = () => {
    dispatch(
      analysisActions.toggleAnalysisOptions({
        type: "annotation",
        value: false,
      })
    );
    dispatch(contextBuilderActions.changePage("analyze"));
  };

  const handlePageChangeForSosAndSod = async () => {
    //console.log(selectedAudit,"audit selected")
    dispatch(contextBuilderActions.changePage("sosAndSod"));

    try {
      dispatch(feedbackActions.setLoading(true));
      const response = await axios.post("/get_context/sos_sod_analysis", {
        config: config.tag,
        auditId: selectedAudit,
      });
      const responseData = response.data;
      //console.log(responseData);
      dispatch(sosAndSodActions.setSodResponse(responseData));
      dispatch(feedbackActions.setLoading(false));
    } catch (err) {
      console.log(err);
    }
  };

  // below code added
  const handlePageChangeForQaAnalysis = async () => {
    dispatch(contextBuilderActions.changePage("qaAnalysis"));
  };

  const handleOptionChange = (e, type) => {
    let updated_selected_option = { ...selectedOption };
    Object.keys(updated_selected_option).map((option) => {
      if (option === type) {
        updated_selected_option[option] = e;
      } else {
        updated_selected_option[option] = "";
      }
    });

    let audit_list = [];
    const auditIdIndex = storeData[0].indexOf("auditID");
    const category_idx = storeData[0].indexOf("category");
    const store_type_idx = storeData[0].indexOf("store_type");
    const annotationStatusIdx = storeData[0].indexOf("annotationStatus");
    storeData.map((row) => {
      if (row.includes(e)) {
        audit_list.push({
          audit: row[auditIdIndex],
          category: row[category_idx],
          store_type: row[store_type_idx],
          annotated: row[annotationStatusIdx] === "annotated" ? "A" : "NA",
        });
      }
    });

    dispatch(defaultTabActions.setAuditList(audit_list));
    dispatch(defaultTabActions.setSelectedOption(updated_selected_option));
  };

  const createBrandHierarchy = (auditDetails) => {
    let brand_data_raw = [];
    try {
      auditDetails.map((image) => {
        if (image.thumbnailsDetails.length === 0) {
          return;
        }

        image.thumbnailsDetails.map((thumbnails) => {
          if (!thumbnails) {
            return;
          }
          if (
            thumbnails.secCategory[0] === "SHELF" ||
            thumbnails.secCategory[0] === "DISPLAY" ||
            thumbnails.isShelf === 1
          ) {
            return;
          }

          let object_to_push = {
            image_name: image.imageName,
            ...thumbnails.ai_data,
          };

          brand_data_raw.push(object_to_push);
        });
      });
    } catch (error) {
      console.log("err", error);
    }

    const brandList = [...new Set(brand_data_raw.map((b) => b["sku_name"]))];
    const variantList = [
      ...new Set(
        brand_data_raw.map((b) => b["sku_name"] + "_" + b["sub_sku_name"])
      ),
    ];
    const skuList = [...new Set(brand_data_raw.map((b) => b["skus"]))];

    dispatch(defaultTabActions.setSkuInfoRaw(brand_data_raw));
    dispatch(defaultTabActions.setBrands(brandList));
    dispatch(defaultTabActions.setVariants(variantList));
    dispatch(defaultTabActions.setSkus(skuList));
  };

  const generateAnnnotationDetails = (data) => {
    /**
     * caclulating annotation data (common predictions, false positives, false negatives)
     * per annotated image, if any
     * NOTE: for calculating common predictions, false positives & false negatives
     * AI data is taken from base project & HI data is taken from variant project
     * i.e.; only those thumbnails will be considered in annotations which are present in AI data.
     */
    let annotationDetails = [];
    const annotatedData = data.filter(
      (r) => r.isAnnotated === 1 && r.lComp === 1 && r.cComp === 1
    );
    const baseData = data.filter(
      (r) => r.isAnnotated === 1 && r.projectName === baseProject
    );
    const variantProjects = [
      ...new Set(annotatedData.map((r) => r.projectName)),
    ];

    console.log(
      "data => annotatedData => baseData",
      data.filter((r) => r.isAnnotated === 1),
      annotatedData,
      baseData
    );

    // iterating through annotated images, &
    // saving data for those thumbnails which exists in base counterpart
    for (let image of annotatedData) {
      let currentImageDetails = {
        imageName: image.imageName,
        projectName: image.projectName,
        common: [],
        falsePositive: [],
        falseNegative: [],
      };
      const thumbnailsHI = image.thumbnailsDetails; // from annotated data
      const baseImageDetails = baseData.filter(
        (r) => r.imageName === image.imageName
      );

      if (baseImageDetails.length > 0) {
        const thumbnailsAI = baseImageDetails[0].thumbnailsDetails; // from base data
        const thumbnailListAI = thumbnailsAI.map((r) => r.thumbnailName);

        for (let thumbnail of thumbnailsHI) {
          if (!("ai_data" in thumbnail) || !("hi_data" in thumbnail)) {
            // if ai_data or hi_data is not present, then continue
            continue;
          }

          if (
            thumbnail.ai_data.sku_name.toLowerCase() === "shelf" ||
            thumbnail.ai_data.sku_name.toLowerCase() === "posm"
          ) {
            // ignoring if predictions are shelf or posm
            continue;
          }

          const thumbnailNameHI = thumbnail.thumbnailName;

          // checking if above HI thumbnail is present in base image data
          if (thumbnailListAI.includes(thumbnailNameHI)) {
            const thumbnailCheck = thumbnailsAI.filter(
              (r) => r.thumbnailName === thumbnailNameHI
            );
            if (thumbnailCheck.length > 0) {
              const AIDataFromBaseImage = thumbnailCheck[0]["ai_data"];
              const HIDataFromAnnotatedImage = thumbnail.hi_data;

              // sorting AI & HI thumbnail data into common, false positives & false negatives based on conditions
              if (
                AIDataFromBaseImage.sub_sku_id === "-" &&
                HIDataFromAnnotatedImage.sub_sku_id === "-"
              ) {
                // if predictions are common in ai & hi but equal to "-"
                continue;
              } else if (
                AIDataFromBaseImage.sub_sku_id ===
                HIDataFromAnnotatedImage.sub_sku_id
              ) {
                // if predictions are common in ai & hi
                let common = currentImageDetails.common;
                common.push({
                  thumbnailName: thumbnailNameHI,
                  ai_data: AIDataFromBaseImage,
                  hi_data: HIDataFromAnnotatedImage,
                });

                currentImageDetails.common = common;
              } else if (
                (AIDataFromBaseImage !== "-" &&
                  HIDataFromAnnotatedImage === "-") ||
                AIDataFromBaseImage.sub_sku_id !==
                  HIDataFromAnnotatedImage.sub_sku_id
              ) {
                // if predictions are present in ai but not in hi (false positive)
                //  or they are different, but not "-"
                let falsePositive = currentImageDetails.falsePositive;
                falsePositive.push({
                  thumbnailName: thumbnailNameHI,
                  ai_data: AIDataFromBaseImage,
                  hi_data: HIDataFromAnnotatedImage,
                });

                currentImageDetails.falsePositive = falsePositive;
              } else if (
                AIDataFromBaseImage === "-" &&
                HIDataFromAnnotatedImage !== "-"
              ) {
                // if predictions is not present in ai but present in hi (false negative)
                let falseNegative = currentImageDetails.falseNegative;
                falseNegative.push({
                  thumbnailName: thumbnailNameHI,
                  ai_data: AIDataFromBaseImage,
                  hi_data: HIDataFromAnnotatedImage,
                });

                currentImageDetails.falseNegative = falseNegative;
              }
            }
          }
        }

        annotationDetails.push(currentImageDetails);
      }
    }

    console.log("annotation details", annotationDetails);
    let common = 0;
    let falsePositive = 0;
    let falseNegative = 0;
    annotationDetails.map((r) => {
      common += r.common.length;
      falsePositive += r.falsePositive.length;
      falseNegative += r.falseNegative.length;
    });
    dispatch(
      analysisActions.changeAnnotationOptions({
        type: "common",
        property: "value",
        value: common,
      })
    );
    dispatch(
      analysisActions.changeAnnotationOptions({
        type: "falsePositive",
        property: "value",
        value: falsePositive,
      })
    );
    dispatch(
      analysisActions.changeAnnotationOptions({
        type: "falseNegative",
        property: "value",
        value: falseNegative,
      })
    );
    dispatch(defaultTabActions.setAnnotationDetails(annotationDetails));
    dispatch(projectInfoActions.setVariantProjects(variantProjects));
  };

  const downloadAuditDetails = (audit) => {
    dispatch(analysisActions.resetAnalysisStateToDefault());
    dispatch(imageAnalysisActions.resetImageAnalysisState());
    dispatch(defaultTabActions.setSelectedAudit(audit));
    dispatch(sosAndSodActions.setSodResponse([]));
    const params = {
      audit: audit,
      config: config.tag,
    };
    dispatch(feedbackActions.setLoading(true));
    axios
      .post("/get_context/get_audit_context", params)
      .then((response) => {
        if (Object.keys(response.data["AuditResults"]).length > 0) {
          dispatch(
            sosAndSodActions.setAuditResultData(response.data["AuditResults"])
          );
        }

        if (Object.keys(response.data["AuditDetails"]).length > 0) {
          dispatch(
            defaultTabActions.setImageDetails(response.data["AuditDetails"])
          );
          dispatch(feedbackActions.setLoading(false));
          createBrandHierarchy(response.data["AuditDetails"]);
          generateAnnnotationDetails(response.data["AuditDetails"]);
        } else {
          dispatch(feedbackActions.setSnackbarOpen(true));
          dispatch(feedbackActions.setSnackbarMessage("Data unavailable!"));
          dispatch(feedbackActions.setSnackbarMessageSeverity("warning"));
          dispatch(feedbackActions.setLoading(false));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {}, [storeData]);

  useEffect(() => {
    // manipulating data according to annotation status
    if (Object.keys(rawData).length > 0) {
      let data = rawData;
      if (annotation) {
        // filtering data if annotation filter is on
        let key = Object.keys(data)[0];
        let aoa = Object.values(data)[0];
        const cols = aoa[0];
        const annotationStatusIdx = aoa[0].indexOf("annotationStatus");
        data = {
          [key]: [
            cols,
            ...aoa.filter((r) => r[annotationStatusIdx] === "annotated"),
          ],
        };
      }

      console.log("data cp", data);
      dispatch(defaultTabActions.setStoreData(Object.values(data)[0]));
      make_list("store", data);
    }
  }, [annotation]);

  const handleChangeSelectedType = () => {
    if (selectedType === "category") {
      dispatch(defaultTabActions.setSelectedType("audits"));
    } else if (selectedType === "audits") {
      dispatch(defaultTabActions.setSelectedType("category"));
    }
  };

  const handleSearchModeChange = () => {
    const currentModeIdx = searchModes.indexOf(currentSearchMode);
    const updatedSearchMode =
      currentModeIdx === searchModes.length - 1
        ? searchModes[0]
        : searchModes[currentModeIdx + 1];
    dispatch(defaultTabActions.changeSearchMode(updatedSearchMode));
    dispatch(defaultTabActions.resetDefaultTabStateToDefault());
    dispatch(analysisActions.resetAnalysisStateToDefault());
    dispatch(imageAnalysisActions.resetImageAnalysisState());
    dispatch(
      analysisActions.toggleAnalysisOptions({
        type: "annotation",
        value: false,
      })
    );
  };

  let placeholder = "yyyy-mm-dd";
  if (currentSearchMode === "Date") {
    placeholder = "yyyy-mm-dd";
  } else if (currentSearchMode === "Audit") {
    placeholder = "search by audit";
  } else if (currentSearchMode === "Session Audit") {
    placeholder = "search by session audit";
  }
  const handleAnalysisOptionChange = async (type) => {
    dispatch(
      analysisActions.toggleAnalysisOptions({
        type: type,
        value: !analysisOptions[type]["selected"],
      })
    );
  };
  // console.log(selectedAudit,"514")
  return (
    <Stack sx={context_styles}>
      <Stack
        spacing={1.5}
        sx={{ p: 1 }}
        direction="row"
        className="search-container"
      >
        {/* Search Mode */}
        <BootstrapTooltip
          title={`Search by ${currentSearchMode}`}
          placement="top"
        >
          <ChevronRightIcon
            className="search-mode-toggle"
            sx={{
              backgroundColor: col_100,
            }}
            onClick={handleSearchModeChange}
          />
        </BootstrapTooltip>

        {/* search bar */}
        {/* <input
          className="search-field-dark"
          placeholder={placeholder}
          defaultValue={searchEntity}
          onChange={handleTextChange}
          onKeyDown={handleKeyDown}
        /> */}

        <LocalizationProvider dateAdapter={AdapterMoment}>
          <Stack
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
            direction="row"
            spacing={1}
          >
            <DatePickerWhite
              sx={{
                width: "11rem",
                border: "none",
                borderRadius: "5px",
                "& .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.MuiInputBase-adornedEnd.css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root":
                  {
                    height: "40px",
                  },
              }}
              value={searchEntity}
              onChange={(newDate) => handleTextChange(newDate)}
              renderInput={(params) => (
                <TextField variant="outlined" size="small" {...params} />
              )}
              format="YYYY-MM-DD"
            />
          </Stack>
        </LocalizationProvider>
        {/* Annotation filter */}
        <BootstrapTooltip title="toggle annotation filter" placement="top">
          <span
            style={{
              fontSize: "0.875rem",
              padding: "0.15rem 0.3rem",
              color: annotation ? color : "rgba(245, 245, 245, 0.35)",
              border: "1px solid rgb(77, 77, 79)",
              borderRadius: "5px",
              cursor: "pointer",
            }}
            onClick={() => handleAnalysisOptionChange("annotation")}
          >
            A
          </span>
        </BootstrapTooltip>
      </Stack>

      {/* selection tree */}
      <Collapse in={storeData.length > 0} timeout={350} unmountOnExit>
        <Stack spacing={0}>
          {storeList.length > 0 && (
            <StyledAutocompleteDark
              sx={{ width: "15rem" }}
              classes={{
                option: autocomplete_classes.option,
              }}
              id="size-small-outlined-multi"
              size="small"
              noOptionsText="Loading..."
              value={selectedOption["store"]}
              componentsProps={{ popper: { style: { width: "fit-content" } } }}
              options={storeList}
              getOptionLabel={(option) => option}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder={`Stores   ( ${storeList.length} )`}
                />
              )}
              onChange={(event, value) => handleOptionChange(value, "store")}
            />
          )}

          {userList.length > 0 && (
            <StyledAutocompleteDark
              sx={{ width: "15rem" }}
              classes={{
                option: autocomplete_classes.option,
              }}
              id="size-small-outlined-multi"
              size="small"
              noOptionsText="Loading..."
              value={selectedOption["user"]}
              componentsProps={{ popper: { style: { width: "fit-content" } } }}
              options={userList}
              getOptionLabel={(option) => option}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder={`Users   ( ${userList.length} )`}
                />
              )}
              onChange={(event, value) => handleOptionChange(value, "user")}
            />
          )}

          {sessionAuditList.length > 0 && (
            <StyledAutocompleteDark
              sx={{ width: "15rem" }}
              classes={{
                option: autocomplete_classes.option,
              }}
              id="size-small-outlined-multi"
              size="small"
              noOptionsText="Loading..."
              value={selectedOption["session_audit"]}
              componentsProps={{ popper: { style: { width: "fit-content" } } }}
              options={sessionAuditList}
              getOptionLabel={(option) => option}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder={`Session Audits   ( ${sessionAuditList.length} )`}
                />
              )}
              onChange={(event, value) =>
                handleOptionChange(value, "session_audit")
              }
            />
          )}
        </Stack>
      </Collapse>

      {/* list */}
      <Collapse in={audits.length > 0} timeout={350} unmountOnExit>
        {audits.length > 0 && (
          <Stack spacing={1.5} sx={{ margin: "1rem auto" }}>
            <span
              className="list-header-dark"
              onClick={handleChangeSelectedType}
            >
              {selectedType === "category"
                ? `Category (${audits.length})`
                : `Audits (${audits.length})`}
            </span>
            <div style={list_styles} className="context-scroll-dark">
              <Stack spacing={1.5}>
                {audits &&
                  audits.map((item) => (
                    <span
                      className={`list-item-dark ${
                        item.audit === selectedAudit
                          ? "selected-audit-dark"
                          : ""
                      }`}
                      onClick={() => downloadAuditDetails(item.audit)}
                    >
                      {selectedType === "category"
                        ? item.category.replace(/_/g, " ") +
                          " | " +
                          item.store_type +
                          " | " +
                          item.annotated
                        : item.audit + " | " + item.annotated}
                    </span>
                  ))}
              </Stack>
            </div>
            {/* {selectedAudit !== "" && (
              <span className="analyze-audit-dark" onClick={handlePageChange}>
                analyze audit
                <KeyboardDoubleArrowRightIcon />
              </span>
            )}
            {selectedAudit !== "" && (
              <span
                className="analyze-audit-dark"
                onClick={handlePageChangeForSosAndSod}
              >
                analyze sos and sod
                <KeyboardDoubleArrowRightIcon />
              </span>
            )}

            {selectedAudit !== "" && (
              <span
                className="analyze-audit-dark"
                onClick={handlePageChangeForQaAnalysis}
              >
                QA Analysis
                <KeyboardDoubleArrowRightIcon />
              </span>
            )} */}
            <Box
              sx={{
                display: "grid",
                rowGap: "10px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {selectedAudit !== "" && (
                <div
                  className="analysis-segway"
                  onClick={handlePageChange}
                >
                  analyze audit
                  {/* <KeyboardDoubleArrowRightIcon /> */}
                </div>
              )}

              {selectedAudit !== "" && (
                <div
                  className="analysis-segway"
                  onClick={handlePageChangeForSosAndSod}
                >
                  analyze SOS and SOD
                  {/* <KeyboardDoubleArrowRightIcon /> */}
                </div>
              )}

              {selectedAudit !== "" && (
                <div
                  className="analysis-segway"
                  onClick={handlePageChangeForQaAnalysis}
                >
                  QA analysis
                  {/* <KeyboardDoubleArrowRightIcon /> */}
                </div>
              )}
            </Box>
          </Stack>
        )}
      </Collapse>
    </Stack>
  );
}
